import { CONTENT_EXPERIENCE } from "./constants";

export const USER_ROLES = {
    ADMIN: "Sportybot Admins",
    CLUB: "Sportybot Club User",
    MILB_CLUB: "Sportybot MiLB Club User",
    INTERNAL_EDITORIAL: "Sportybot Internal Editorial",
    INTERNAL_GENERAL: "Sportybot Internal General",
    INTERNAL_SOCIAL: "Sportybot Internal Social",
    INTERNAL_PILOT: "Sportybot Internal Pilot"
};

export const USER_PERMISSIONS = {
    CAN_SEND_TO_FORGE: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_PILOT
    ],
    CAN_ACCESS_RULES: [USER_ROLES.ADMIN, USER_ROLES.INTERNAL_GENERAL],
    CAN_VIEW_ALL_RULES: [USER_ROLES.ADMIN],
    CAN_ACCESS_RESEARCH_TOOL: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_PILOT
    ],
    CAN_DOWNLOAD_VIDEOS: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB,
        USER_ROLES.MILB_CLUB
    ],
    CAN_ACCESS_INTERNAL: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB
    ],
    CAN_ACCESS_ADHOC_CLIPPING: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB
    ],
    CAN_VIEW_ALL_CUSTOM_CLIPS: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB
    ]
};

export const EXPERIENCE_ROLES = {
    [CONTENT_EXPERIENCE.MLB]: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB
    ],
    [CONTENT_EXPERIENCE.MILB]: [
        USER_ROLES.ADMIN,
        USER_ROLES.INTERNAL_GENERAL,
        USER_ROLES.INTERNAL_EDITORIAL,
        USER_ROLES.INTERNAL_SOCIAL,
        USER_ROLES.CLUB,
        USER_ROLES.MILB_CLUB
    ]
};

export const TEST_GROUP_ID_MAPPING = {
    [USER_ROLES.INTERNAL_PILOT]: "j22s"
};

export const ALL_TEST_GROUPS = Object.keys(TEST_GROUP_ID_MAPPING);



// WEBPACK FOOTER //
// ./src/utils/authConstants.js